module.exports = __webpack_public_path__ + "img/logo.d29a90df.png";